<template>
  <div class="tw-flex tw-mt-10 md:tw-mt-6">
    <div class="tw-ml-5 tw-pt-4">
      <h2 class="tw-text-xl md:tw-text-2xl c-blue-text title-font"><slot></slot></h2>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CardTitle',
  props: {
    icon: {
      type: String,
      default: 'mdi-shield-car',
    },
  },
};
</script>
